export default __webpack_public_path__ + "static/media/sledz-nas-mobile.8ab5ff95.jpg";